import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {LogIn} from "@repo/auth-login";
import {NeedAnAccount} from "@repo/auth-signup";
import {RequestInfo} from "@repo/shared-core";
import {mediaQueries} from "@repo/shared-styles";

import PageRoot from "#app-shell-package/page-root.tsx";
import {RefreshForKhanmigo} from "#guide-browser-extension/refresh-for-khanmigo.tsx";

/**
 * A page to allow the user to log in via any method of their choice.
 * This includes email/password, Google, Facebook, Apple, and Clever
 */
const LogInPage = () => {
    return (
        <PageRoot settings={{footer: false, noIndex: true, noFollow: true}}>
            <View style={styles.page}>
                <LogIn signupComponent={<NeedAnAccount />} />
                {RequestInfo.isExtension && <RefreshForKhanmigo />}
            </View>
        </PageRoot>
    );
};

const styles = StyleSheet.create({
    page: {
        marginTop: spacing.large_24,
        [mediaQueries.lgOrLarger]: {
            marginTop: spacing.xxLarge_48,
        },
    },
});

export default LogInPage;
